// extracted by mini-css-extract-plugin
export default {"filter":"Filters_filter__WNX9T","filter_wrapper":"Filters_filter_wrapper__w+YHI","train_place":"Filters_train_place__tHruJ","filter_border":"Filters_filter_border__OlCIV"};